module.exports = __webpack_public_path__ + "static/0chain-supplychain-4a70064c8a41e64406edac36996545d9.png";